import React from 'react'
import { Avatar } from 'src/components/global/Avatar/Avatar'

interface Props {
  founder: any
}

/**
 * Component to render founder item in ALSP/Consultancy enhanced listing page > Overview Tab.
 */
export const SolutionFounderItem: React.FC<Props> = ({ founder }) => {
  if (!founder.name && !founder.title) return null
  return (
    <>
      <div className="flex flex-row items-center">
        <div className="mr-2">
          <Avatar
            size="40px"
            initialsTextSize="12px"
            url={founder.avatar?.url}
            name={founder.name || founder.title || ''}
            defaultMode="initials"
            border="circle"
            variant="navy"
          />
        </div>

        {founder?.externalLink ? (
          <a
            target={'_blank'}
            href={founder.externalLink || '#'}
            className="text-[0.75rem] mr-2 underline cursor-pointer underline-offset-[4px]"
            style={{ color: '#333333' }}
          >
            {[founder?.name, founder?.title]?.filter(Boolean).join(' - ')}
          </a>
        ) : (
          <div className="text-[0.75rem] mr-2 hover:no-underline" style={{ color: '#333333' }}>
            {[founder?.name, founder?.title]?.filter(Boolean).join(' - ')}
          </div>
        )}
      </div>
      {'experiencedFounder' in founder && founder?.experiencedFounder == true && (
        <label className="pl-2 experienceFounder">Experienced Founder</label>
      )}
    </>
  )
}
